import { SettingModel } from '../../models/settings';
import ApiClient from '../ApiClient';
import { NiceResponse } from '../dto/NiceResponse';
import { SettingCreateRequest } from './dto/SettingCreateRequest.dto';

export class SettingsApi {
  // eslint-disable-next-line no-unused-vars
  constructor(private api: ApiClient) {}

  path = '/settings';

  async create(req: SettingCreateRequest) {
    const resp = await this.api.client.post<NiceResponse<null>>(
      this.path + '/create',
      { ...req },
    );
    return resp.data;
  }

  async update(req: SettingCreateRequest, id: string) {
    const resp = await this.api.client.put<NiceResponse<null>>(
      this.path + '/update/' + id,
      { ...req },
    );
    return resp.data;
  }

  async delete(id: string) {
    const resp = await this.api.client.delete<NiceResponse<null>>(
      this.path + '/delete/' + id,
    );
    return resp.data;
  }

  async get(skip: number, take: number) {
    const resp = await this.api.client.get<NiceResponse<SettingModel[]>>(
      this.path + '/list?skip=' + skip + '&take=' + take,
    );
    return resp.data;
  }
}
